
import { defineComponent } from 'vue';
import TheDetailPageHeader from '@/components/organisms/detailPage/TheDetailPageHeader.vue';
import TheDetailPageBody from '@/components/organisms/detailPage/TheDetailPageBody.vue';
import Heading from '@/components/atoms/Heading.vue';
import ScheduleBox from '@/components/molecules/schedule/ScheduleBox.vue';
/*
import SignalText from '@/components/atoms/SignalText.vue';
import LinkButton from '@/components/organisms/utils/LinkButton.vue';
*/

export default defineComponent({
  name: 'ScheduleTemplate',
  components: {
    TheDetailPageHeader,
    TheDetailPageBody,
    Heading,
    ScheduleBox,
    /*
    SignalText,
    LinkButton,
    */
  },
  props: {
    i18n: {
      type: Object,
    },
  },
});
